import { defineMessages } from 'react-intl';

export default defineMessages({
  AAmodalDeletePINMsgErr: {
    defaultMessage: 'There was an error, please try again',
    id: 'AAmodal.deletePIN.msgErr',
  },
  AAmodalDeletePINMsgSucc: {
    defaultMessage: 'PIN deleted successfully',
    id: 'AAmodal.deletePIN.msgSucc',
  },
  AAmodalDeleteRFIDMsgErr: {
    defaultMessage: 'There was an error, please try again',
    id: 'AAmodal.deleteRFID.msgErr',
  },
  AAmodalDeleteRFIDMsgSucc: {
    defaultMessage: 'RFID key fob deleted successfully',
    id: 'AAmodal.deleteRFID.msgSucc',
  },
  AAmodalGeneratePINMsgErr: {
    defaultMessage: 'There was an error, please try again',
    id: 'AAmodal.generatePIN.msgErr',
  },
  AAmodalGeneratePINMsgSucc: {
    defaultMessage: 'PIN generated successfully',
    id: 'AAmodal.generatePIN.msgSucc',
  },
  AASnackbarPinGeneratedFailed: {
    defaultMessage: 'There was an error, please try again',
    id: 'AAmodal.newPIN.msgErr',
  },
  AASnackbarPinGeneratedSuccessfully: {
    defaultMessage: 'PIN generated successfully',
    id: 'AAmodal.newPIN.msgSucc',
  },
  AAUserDetailCallingMobileVideoMsgErr: {
    defaultMessage: 'There was an error, please try again',
    id: 'AA.userDetail.calling.mobileVideo.msgErr',
  },
  AAUserDetailCallingMobileVideoMsgSucc: {
    defaultMessage: 'Mobile Video changed successfully',
    id: 'AA.userDetail.calling.mobileVideo.msgSucc',
  },
});
